/**
 * Created by pandemio on 2/12/19.
 */
import React from 'react';
import {Button } from 'reactstrap';

/**
 * Pagination class. Created because the one we found, the one from react bootstrap table
 * did not work with updating the current selected page and the page totals.
 * That's why we decided to create our own component, which works great for
 * service calls
 */
class Pagination extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            totalPages: props.totalPages ? props.totalPages : 1,
            currentPage: props.currentPage ? props.currentPage : 1
        };

        this.onPageClick = this.onPageClick.bind(this);
    }

    componentWillReceiveProps(props){
        this.setState({
            totalPages: props.totalPages ? props.totalPages : 1,
            currentPage: props.currentPage ? props.currentPage : 1
        });
    }

    onPageClick(e){
        this.props.updateParent(e.target.value);
    }

    /**
     * Renders the pagination, always refreshing according to results
     * @returns {XML}
     */
    render() {
        // If the total of pages is less than 5, or the currentPage + 2 is more than the total Pages, show the rest of
        // buttons
        let maxPages;

        if(parseInt(this.state.totalPages) <= 5)
            maxPages = parseInt(this.state.totalPages);
        else
            maxPages = parseInt(this.state.currentPage) + 2;

        // If there are more than 5 results, and the current page is less than 5, show 5 numbers at least
        if(maxPages < 5 && parseInt(this.state.totalPages) >= 5)
            maxPages = 5;

        // The max pages cannot be more than the total of pages
        if(maxPages > parseInt(this.state.totalPages))
            maxPages = parseInt(this.state.totalPages);

        let minPages =
            this.state.currentPage - 2 < 1 ? 1 : this.state.currentPage - 2;

        if(this.state.totalPages <= 5 || (this.state.currentPage - 2 <= 0))
            minPages = 1;

        let options = [];
        for(let i=minPages; i <= maxPages; i++)
        {
            let optionToPush = {
                value: i, name: i
            };
            optionToPush.clicked = parseInt(this.state.currentPage) === i;
            options.push(optionToPush);
        }
        return (
            <div>
                {options.map((d, idx)=>{
                    let color = d.clicked ? "info" : "warning";
                    return (<Button onClick={this.onPageClick} color={color} value={d.value} key={idx}>{d.name}</Button>)
                })}
            </div>
        );
    }
}

export default Pagination;